export default __webpack_public_path__ + "static/media/need_login_register.2d3066c2.png";